import React from 'react';
import ReactDOM from 'react-dom';
import { Dropdown } from '@wearesection/raise-ui/atoms';

type Option = {
	label: string;
	value: string;
};
function ReactRenderDropdownBlock( dropdown: HTMLElement ) {
	// integrate Dropdown from DLS for Hubspot dropdown select field
	if ( dropdown ) {
		const selectELe = dropdown.querySelector( 'select' ) as HTMLSelectElement;
		const selectOption = Array.from( selectELe.querySelectorAll( 'option' ) ) as Array< HTMLOptionElement >;
		const dataOption: Option[] = selectOption.slice( 1 ).map( ( item: HTMLOptionElement ) => ( {
			label: item.innerText,
			value: item.value,
		} ) );
		const customEleWrapper = document.createElement( 'div' );
		dropdown.appendChild( customEleWrapper );
		const handleClickOption = ( value: string ) => {
			const resultELe = dropdown.querySelector( '.result-label' ) as HTMLElement;
			const initialHSSelectField = dropdown.querySelector(
				'select',
			) as HTMLSelectElement;
			const dropdownLabel = dropdown.querySelector( 'div[role="button"]' ) as HTMLSpanElement;
			dropdownLabel.classList.add( 'active' );

			if ( initialHSSelectField ) {
				initialHSSelectField.value = value;
				const initialSelectFieldOption = initialHSSelectField.querySelector(
					`option[value="${ value }"]`,
				) as HTMLOptionElement;
				initialHSSelectField.dispatchEvent( new Event( 'change', { bubbles: true } ) );
				resultELe.innerHTML = initialSelectFieldOption.innerText;
			}
			dropdown.querySelector( '.dropdown-content ' )?.classList.remove( 'active' );
			dropdownLabel.classList.remove( 'open' );
			// Active option
			const selectedOutDate = dropdown.querySelector('.dropdown-content li.active') as HTMLElement;
			selectedOutDate && selectedOutDate.classList.remove('active')
			const selectedOption = (Array.from(dropdown.querySelectorAll('.dropdown-content li')) as Array<HTMLElement> )?.find(item => item?.dataset?.value === value)
			selectedOption &&  selectedOption.classList.add('active')
		};
		ReactDOM.render(
			<>
				<Dropdown onItemClick={ handleClickOption } items={ dataOption }>
					<>
						{ selectOption?.[ 0 ]?.innerText }
						<p className="result-label line-clamp-1"></p>
					</>
				</Dropdown>
			</>,
			customEleWrapper,
		);
	}
}

export default ReactRenderDropdownBlock;
